<app-page-header [heading]="'VAT Report'" [icon]="'fa-calendar'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row">
    <div class="form-group col-lg-4">
      <label>From</label>
      <input (ngModelChange)="fromdate = $event" [max]="getToday()" [ngModel]="fromdate | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">

    </div>
    <div class="form-group col-lg-4">
      <label>To</label>
      <input (ngModelChange)="todate = $event" [max]="getToday()" [ngModel]="todate | date:'yyyy-MM-dd'"
             class="form-control " id="todate" name="todate" type="date">
    </div>
    <div class="form-group col-lg-4">
      <label></label><br>
      <button (click)="listVatReport();" class="btn btn-info btn-sm ng-star-inserted" type="button">&nbsp;Search&nbsp;
      </button>

    </div>
    <div class=" col-12">
      <table class="table tbl table-bordered" style="background-color: #f3f8fd">
        <thead>
        <tr class="text-center">
          <th rowspan="2" width="5%">Sl</th>
          <th rowspan="2">Item</th>
          <th colspan="4" width="20%">Purchase VAT</th>
          <th rowspan="2" width="20%">Sale VAT</th>
          <th rowspan="2" width="10%">Balance VAT</th>
        </tr>
        <tr>
          <th>VAT</th>
          <th>Total</th>
          <th>VAT</th>
          <th>Total</th>
        </tr>
        <tr *ngIf="(stock_data | json) == '[]'">
          <td class="text-center" colspan="13">No data to list</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let stock of stock_data;let i=index">
          <td class="text-center">{{ i + 1 }}</td>
          <td> {{ stock.TRADE_NAME }}</td>
          <td>{{ stock.VAT_AMOUNT | number : '1.2-2' }}</td>
          <td>{{ stock.PURCHASE_VAT | number : '1.2-2' }}</td>
          <td>{{ stock.SALE_VAT_AMOUNT }}</td>
          <td>{{ stock.SALE_VAT }}</td>
          <td class="text-center">{{ stock.BALANCE_VAT | number : '1.2-2' }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

